import { SagaIterator } from '@redux-saga/core'
import { all, put, takeLatest, call } from 'redux-saga/effects'
import { CONTENT } from 'ducks/registerLayout'
import getRegisterLayout from 'services/getRegisterLayout'
import { Action } from 'lib/redux/models'

function* loadRegisterLayout(action: Action) {
  yield put(CONTENT.request())
  try {
    const data = yield call(getRegisterLayout, action?.payload)
    if (data) {
      yield put(CONTENT.success(data))
    }
  } catch (error) {
    yield put(CONTENT.failure(error.message))
  } finally {
    yield put(CONTENT.fulfill())
  }
}

export function* registerLayoutSagas(): SagaIterator {
  yield all([takeLatest(CONTENT.TRIGGER, loadRegisterLayout)])
}
